import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceRequestTypeDto extends EpimsBaseEntityDto {
  CorrespondenceRequestTypeName: string;
  CorrespondenceRequestCategoryId: string;
}
